import { Text, View } from "@react-pdf/renderer";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import packageJson from "../../../package.json";
import { configurationState } from "../../state/state";
import { getRecoil } from "recoil-nexus";

const PdfFooter: FunctionComponent<{ height: number }> = ({ height }) => {
  const { t } = useTranslation();
  const appConfig = getRecoil(configurationState);

  return (
    <View
      fixed={true}
      style={{
        width: "100%",
        height,
        backgroundColor: "#e8e8e8",
        position: "absolute",
        bottom: 0,
        flexDirection: "column",
        justifyContent: "space-around",
      }}
    >
      <Text
        style={{
          textAlign: "right",
          paddingRight: 15,
          fontSize: 8,
        }}
      >
        App Version: {packageJson.version} - Config Version: {appConfig.version}
      </Text>
      <Text
        style={{
          textAlign: "right",
          paddingRight: 15,
          fontSize: 10,
          fontWeight: "bold",
        }}
      >
        {t("components.pdfExport.footerLinkLabel")}
      </Text>
    </View>
  );
};

export default PdfFooter;
